
export enum PickupStatus {
  UNASSIGNED = "UNASSIGNED",
  ASSIGNED = "ASSIGNED",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED"
};
